// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Cq-z","subtitle":"Dq-z","contentWrap":"Eq-z","imgWrap":"Fq-z","heading":"Gq-z","copy":"Hq-z"};